module.exports = __webpack_public_path__ + "static/img/1_1_1.ec22b696.jpg";